export const formatDateTime = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);

  // Convert UTC → Dallas local time automatically (handles DST)
  return date.toLocaleString('en-IN', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    second: '2-digit',
    hour12: true,
    timeZone: 'America/Chicago', // ✅ Central Time with DST
  });
};
